module.exports = __webpack_public_path__ + "static/media/datos_verde.b9d97789.svg";